import { forwardRef, React, useImperativeHandle, useRef } from 'react'
import FormCreator from '../../../../components/Forms/FormCreator';

const IndividualAccountInformation = forwardRef(({ formData }, ref) => {
  const accountInformationFormRef = useRef();

  useImperativeHandle(ref, () => ({
    getFormData: () => {
      if (ref?.current) {
        const data = accountInformationFormRef.current.getFormData();
        return data;
      }
      return null;
    }
  }));
  

  return (
    <div className="form-field-sec">
      <div className="row gx-5">
        <FormCreator
          ref={accountInformationFormRef}
          {...formData}
        ></FormCreator>
      </div>
    </div>
  )
}
)
export default IndividualAccountInformation;